export enum UIMode {
  Light = "LightMode",
  Dark = "DarkMode",
}
